import { Fragment, useRef, useState } from "react"
import { Box, Card, Flex, Heading, Button, Text } from "rebass/styled-components"
import styled from "styled-components";
import FullLayout2 from "../components/FullLayout"
import Header from "../components/Header"
import { gql, useMutation, useQuery } from "@apollo/client";
import ReactSelect from "react-select";
import { ReactSelectStyles } from "../styles/ReactSelectStyles";
import { toast } from "react-toastify";
import { sleep } from "../utils/sleep";
import { useNavigate } from "react-router-dom";
import IconLoading2 from "../components/icons/IconLoading2";
import { CURRENT_USER } from "../graphql/queries";
import CheckboxInput, { Checkbox } from "../components/CheckboxInput";


const Container = styled(Box)`
  max-width: 1024px;
  width: 100%;
  margin: 0 auto !important;
`;

const CardContainer = styled(Flex)`
  max-width: 400px;
`;

const LogoutWrap = styled(Box)`
  background: #e8e8e8;
  margin-left: -32px;
  margin-bottom: -32px;
  opacity: 0.7;
  transition: all 0.3s ease;
  width: calc(100% + 64px);
  color: #a0a0a0;
  padding: 6px;
  border-radius: 0 0 6px 6px;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`

const IMPERSONATE = gql`
  mutation impersonateProvider($id: String!){
    impersonateProvider(id: $id) {
      token
      user {
        id
        accountLocked
      }
    }
  }
`

interface IImpersonateOutput {
  impersonateProvider: {
    token: string
    user: {
      id: string,
      accountLocked: boolean
    }
  }
}

const GET_HELPSCOUT_USERS = gql`
  query getLocalHelpscoutUsers {
    getLocalHelpscoutUsers {
      id
      firstName
      lastName
    }
  }
`;

interface IHelpscoutUser {
  id: string, firstName?: string, lastName?: string
}

interface IGetHelpscoutUsersOutput {
  getLocalHelpscoutUsers: IHelpscoutUser[];
}

interface IIGetHelpscoutUsersInput { }

interface IImpersonateInput {
  id: string
}

const Impersonate = () => {
  const navigate = useNavigate()
  const [impersonateProvider, setImpersonateProvider] = useState<string>();
  const [scrambleData, setScrambleData] = useState<boolean>(false)
  const { data, loading, error } = useQuery<IGetHelpscoutUsersOutput, IIGetHelpscoutUsersInput>(GET_HELPSCOUT_USERS)
  const [impersonate, { loading: loadingImpersonate }] = useMutation<IImpersonateOutput, IImpersonateInput>(IMPERSONATE, {
    onError: () => {
      toast.update(toastId.current, {
        render: 'An error occured',
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 5000,
        closeButton: null // The closeButton defined on ToastContainer will be used
      });
    }
  })
  const toastId = useRef<any>(null);

  const handleImpersonate = async () => {
    localStorage.removeItem('scramble')
    if (!data || !data.getLocalHelpscoutUsers || !impersonateProvider) return
    const userToImpersonate = data?.getLocalHelpscoutUsers.find(x => x.id.toString() === impersonateProvider)
    if (!userToImpersonate || !userToImpersonate.id) return
    toastId.current = toast(<Flex flexDirection={'column'}>
      <Text fontWeight={400}>Impersonating</Text>
      <Text fontWeight={300}>{`${userToImpersonate?.firstName} ${userToImpersonate?.lastName}`}</Text>
    </Flex>, { autoClose: false, isLoading: true, closeButton: false });
    const initialToken = localStorage.getItem('token');
    let impersonateResult = await impersonate({
      variables: {
        id: userToImpersonate.id.toString()
      },
    });
    if (!impersonateResult || !impersonateResult.data || !impersonateResult.data.impersonateProvider.token) {
      toast.update(toastId.current, {
        render: 'An error occured',
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 5000,
        closeButton: null // The closeButton defined on ToastContainer will be used
      });
      return
    }
    if (scrambleData) {
      localStorage.setItem('scramble', 'true')
    }
    localStorage.setItem('initialToken', initialToken || '');
    localStorage.setItem('token', impersonateResult.data.impersonateProvider.token);
    toast.update(toastId.current, {
      render: 'Impersonation succeeded!',
      type: toast.TYPE.SUCCESS,
      isLoading: false,
      autoClose: 5000,
      closeButton: null // The closeButton defined on ToastContainer will be used
    });
    navigate('/')
  }
  return (
    <FullLayout2 style={{ overflow: 'auto', zIndex: 10 }}>
      <Fragment>
        <Container>
          <Flex flex={1} flexDirection="column">
            <Header dark={false} childContainerStyle={{ marginTop: '-16px' }}>

              <Heading sx={{ marginLeft: '153px' }}>Providers</Heading>
            </Header>
          </Flex>
          <Flex flex={1} alignItems="center" justifyContent="center">
            <CardContainer flex={1} px={3}>
              <Card p={4} >
                <Flex flexDirection="column">
                  {!!loading || !!loadingImpersonate ? (
                    <IconLoading2 style={{ width: '300px', height: 'auto' }} />
                  ) : (<>
                    <Box>
                      <Heading textAlign="center" mb={4}>
                        Choose Provider to Impersonate
                      </Heading>
                    </Box>
                    <Fragment>
                      {!loading && (
                        <ReactSelect
                          styles={{ ...ReactSelectStyles.initialStyles }}
                          options={(data?.getLocalHelpscoutUsers || [] as IHelpscoutUser[]).map(x => {
                            return {
                              label: `${x.firstName} ${x.lastName}`,
                              value: x.id.toString()
                            }
                          })}
                          onChange={e => {
                            if (!e) {
                              return
                            } else {
                              setImpersonateProvider(e.value)
                            }
                          }}
                          placeholder='Pick provider...'

                        />
                      )}

                      <Checkbox label='Scramble data' isChecked={scrambleData} onClick={() => { setScrambleData(!scrambleData) }} />

                      <Button mt={4} disabled={!!loading || !impersonateProvider} alignSelf='center' onClick={handleImpersonate}>Impersonate</Button>
                      <LogoutWrap mt={4}
                        onClick={() => navigate('/logout')}>

                        <Text
                          style={{ textDecoration: 'underline', textAlign: 'center' }}
                        >Logout</Text>
                      </LogoutWrap>
                    </Fragment>
                  </>)}
                </Flex>
              </Card>
            </CardContainer>
          </Flex>
        </Container>
      </Fragment>
    </FullLayout2>
  )
}

export default Impersonate